class RecommendedModal extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('.modal-overlay');
    this.drawer = this.querySelector('.modal-drawer');
    this.closeBtn = this.querySelector('.modal-close');
    this.openBtn = document.getElementById('open-extra-modal-btn');
    this.showCurrencyCode = this.getAttribute('data-show-currency-code') === 'true';
    this.currencyCode = this.getAttribute('data-currency-code');
    this.currencySymbol = this.getAttribute('data-currency-symbol');

    if (this.openBtn && this.modal && this.drawer && this.closeBtn) {
      this.openBtn.addEventListener('click', this.openModal.bind(this));
      this.closeBtn.addEventListener('click', this.closeModal.bind(this));
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.closeModal();
      });
    }

    this.initVariantListeners();
    this.initAddToCartListeners();
    this.initPseudoSelect();
  }

  openModal() {
    this.modal.classList.remove('hidden');
    setTimeout(() => {
      this.drawer.classList.remove('translate-x-full');
    }, 10);
  }

  closeModal() {
    this.drawer.classList.add('translate-x-full');
    setTimeout(() => {
      this.modal.classList.add('hidden');
    }, 300);
  }

  initVariantListeners() {
    this.querySelectorAll('.variant-select-radio').forEach((radio) => {
      radio.addEventListener('change', (e) => {
        const productIndex = radio.getAttribute('data-product-index');
        const price = radio.getAttribute('data-price');
        const priceDiv = this.querySelector(`#product-price-${productIndex}`);
        if (priceDiv) {
          let formattedPrice = Shopify.formatMoney
            ? Shopify.formatMoney(price, window.shopMoneyFormat)
            : (price / 100).toFixed(2);
          formattedPrice = formattedPrice.replace(/(\d+)\.00(?!\d)/, '$1');
          if (this.showCurrencyCode && !formattedPrice.includes(this.currencyCode)) {
            formattedPrice += ' ' + this.currencyCode;
          }
          priceDiv.innerHTML = '<p>' + this.currencySymbol + formattedPrice + '</p>';
        }
        // Update add-to-cart button
        const addBtn = this.querySelector('.add-to-cart-btn[data-product-index="' + productIndex + '"]');
        if (addBtn) {
          addBtn.setAttribute('data-variant-id', radio.value);
        }
      });
    });
  }

  initAddToCartListeners() {
    this.querySelectorAll('.add-to-cart-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          btn.textContent = 'Please select a size';
          setTimeout(() => {
            btn.textContent = 'Add to cart';
            btn.disabled = false;
          }, 1500);
          return;
        }
        btn.disabled = true;
        btn.textContent = 'Adding...';
        if (typeof u !== 'undefined' && u.post) {
          u.post('/cart/add', { id: variantId, quantity: 1 })
            .then((response) => {
              if (response) {
                btn.textContent = 'Added!';
                setTimeout(() => {
                  btn.textContent = 'Add to cart';
                  btn.disabled = false;
                }, 1500);
                this.closeModal();
                setTimeout(() => {
                  // Update cart drawer content and open it
                  const temp = document.createElement('div');
                  temp.innerHTML = response;
                  const newContent = u.qs('.cart-overlay-mask-content', temp);
                  const cartContent = u.qs('.cart-overlay-mask-content', page.navigation);
                  if (newContent && cartContent) {
                    cartContent.innerHTML = newContent.innerHTML;
                  }
                  if (window.page && window.page.initComponents) {
                    window.page.initComponents();
                  }
                  u.ac(page.navigation, 'page-navigation__open');
                  u.ac(page.navigation.cart, 'cart__open');
                  u.ac(page.navigation.cart.action, 'cart-action__open');
                  u.sa(page.navigation.cart.action, { 'aria-expanded': true });
                }, 300);
              }
            })
            .catch(() => {
              btn.textContent = 'Please select a size';
              setTimeout(() => {
                btn.textContent = 'Add to cart';
                btn.disabled = false;
              }, 1500);
            });
        }
      });
    });
  }

  initPseudoSelect() {
    this.querySelectorAll('.offer-options-action').forEach((btn, idx) => {
      const listId = btn.getAttribute('aria-controls');
      const list = this.querySelector(`#${listId}`);
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = btn.classList.contains('offer-options-action__open');
        if (isOpen) {
          btn.classList.remove('offer-options-action__open');
          btn.setAttribute('aria-expanded', 'false');
          list.setAttribute('aria-hidden', 'true');
          list.style.height = 0;
        } else {
          btn.classList.add('offer-options-action__open');
          btn.setAttribute('aria-expanded', 'true');
          list.setAttribute('aria-hidden', 'false');
          list.style.height = list.scrollHeight + 'px';
          btn.textContent = 'Select size';
        }
      });
      // Close on variant select
      list.querySelectorAll('input[type=radio]').forEach((radio) => {
        radio.addEventListener('change', () => {
          btn.classList.remove('offer-options-action__open');
          btn.setAttribute('aria-expanded', 'false');
          list.setAttribute('aria-hidden', 'true');
          list.style.height = 0;
          btn.textContent = radio.dataset.buttonLabel;
        });
      });
    });
  }
}

customElements.define('recommended-modal', RecommendedModal);
